module.exports = __webpack_public_path__ + "static/media/logo7.5215b01b.png";